import { Collapse, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useGetInspectHistSel, useSetInspectHist } from '../../../../../interface/inspect';
import theme from '../../../../../styles/theme';
import CommonDataGrid from '../../../../common/CommonDataGrid';
import NaviText from '../../../common/NaviText';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { useGetCodeList } from '../../../../../interface/common';
import Button from '../../../../common/Button';
import { useGetItemSel } from '../../../../../interface/item';
import { Row } from '../../../../../styles/common';
import { NumericFormat } from 'react-number-format';

const MainWrap = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    overflow-y: auto;

    .naviBar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid ${theme.color.black[10]};
        position:sticky;
        top:0px;
        background: ${theme.color.white[100]};
        z-index:1500;
    }

`;

const NumericFormatCustom = (param) => {
    return (
        <NumericFormat
        type='text'
        displayType='text'
        thousandSeparator
        isNumericString
        prefix="₩ "
        value={param.row.pur_price}
      />
    )
}

const columns = [
    { field: 'tno', headerName: '자산번호', width:140 },
    { field: 'pcat_nm', headerName: '구분', width:100 },
    { field: 'cat_nm', headerName: '분류', width:150 },
    { field: 'lot_no', headerName: '표기번호', width:120 },
    { field: 'maf_nm', headerName: '제조사', width:100 },
    { field: 'model_nm', headerName: '모델명', width:300 },
    { field: 'status_nm', headerName: '자산상태', width:100 },
    { field: 'location', headerName: '위치', width:120 },
    { field: 'model_sub', headerName: '모델유형', width:120 },
    { field: 'serial_no', headerName: '시리얼넘버', width:200 },
    { field: 'maf_date', headerName: '제조일자', width:100 },
    { field: 'pur_date', headerName: '구매일자', width:100 },
    { field: 'pur_tpnm', headerName: '구매구분', width:100 },
    { field: 'pur_price', headerName: '구매가격', width:120, renderCell:NumericFormatCustom},
    { field: 'uid1', headerName: '책임자', width:100 },
    { field: 'uid2', headerName: ' 부책임자', width:100 },
]

const InspectHistItem = ({sno, ispNm, target : paramTarget, onClose}) => {

    const [sendParam, setSendParam] = useState({});
    const [list, setList] = useState([]);
    const [itemToggle, setItemToggle] = useState(false);

    const [target, setTarget] = useState(paramTarget);
    const [mode, setMode] = useState();

    const {data : itemList, isLoading:itemLoading } = useGetItemSel(sendParam);
    const {data : histItemList, isLoading:histItemLoading } = useGetInspectHistSel({sno:sno});

    const {data : ispRetList} = useGetCodeList('isp_ret_st');

    const {mutate} = useSetInspectHist();

    useEffect(()=>{
        if(itemList){
            setList(itemList.map((item,index)=>({...item,id:index})));
        }else{
            setList([])
        }
    },[itemList])

    useEffect(()=>{
        if(target && !histItemLoading){
            handleItemClick(target);
        }
    },[histItemList])

    const handleItemClick = (obj) => {
        if(obj && obj.tid){
            const index = histItemList ? histItemList.findIndex((histTarget)=>histTarget.tid === obj.tid) : -1;
            if(index > -1){
                setMode('MOD');
                const temp = {
                                ...obj,
                                ...histItemList[index]
                            }
                setTarget(temp)
            }else{
                setMode('ADD');
                setTarget({...obj,contents:'',descr:''})
            }
        }else{
            setMode('ADD');
            setTarget({...obj,contents:'',descr:''})
        }
    }

    const handleValueChange = (id, val) => {
        const temp  = {...target,[id]:val}
        setTarget(temp);
    }

    const handleAddClick = () => {
        mutate(
            {...target,sno:sno,mode:'POST'},
            {
                onSuccess:()=>{
                    // handleItemClick(target)
                }
            }
            )
    }
    const handleModClick = () => {
        mutate(
            {...target,sno:sno,mode:'PUT'},
            {
                onSuccess:()=>{
                    // handleItemClick(target)
                }
            }
            )
    }
    const handleDelClick = () => {
        mutate(
            {...target,sno:sno,mode:'DELETE'},
            {
                onSuccess:()=>{
                    // handleItemClick(target)
                }
            }
            )
    }

    return (
        <MainWrap>
            <div className='naviBar'>
                <NaviText target={[{text:'자산관리'},{text:'자산조사'},{text:ispNm},{text:'자산정보'}]} />
                <div className='close' onClick={()=>onClose(false)}>
                    <img src={`/images/ic_close.svg`} />
                </div>
            </div>
            <Row col={5} style={{marginTop:'8px'}}>
                <TextField
                    id='tno' 
                    label='자산번호' 
                    size='small' 
                    InputProps={{
                        readOnly: true,
                    }}
                    InputLabelProps={{shrink:true}} 
                    disabled
                    value={target && target.tno}
                    // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                />
                <TextField 
                        id='model_nm' 
                        label='모델명' 
                        size='small' 
                        InputProps={{
                            readOnly: true,
                        }}
                        InputLabelProps={{shrink:true}} 
                        disabled
                        value={target && target.model_nm}
                        // onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                <TextField
                    label='분류'
                    InputProps={{
                        readOnly: true,
                    }}
                    InputLabelProps={{shrink:true}} 
                    size='small'
                    disabled
                    // placeholder='분류'
                    value={target && target.cat_nm}
                />
            </Row>
            <Row style={{justifyContent:'space-between'}}>
                <FormControl style={{width:'10rem'}} size='small'>
                    <InputLabel id='retSt-label'>조사자산상태</InputLabel>
                    <Select label="조사자산상태" labelId='retSt-label' size='small' value={target && target.ret_st}>
                        <MenuItem 
                            value={''} 
                            onClick={()=>handleValueChange('ret_st','')}
                        >
                            -------
                        </MenuItem>
                        {ispRetList && ispRetList.map((item,index)=>{
                            return <MenuItem 
                                        key={index} 
                                        value={item.code} 
                                        onClick={()=>handleValueChange('ret_st',item.code)}
                                    >
                                        {item.value}
                                    </MenuItem>
                        })}
                    </Select>
                </FormControl>
                <Row style={{margin:0,padding:0}}>
                    {mode === 'ADD' &&
                        <Button onClick={handleAddClick} style={{margin:'0',width:'100px'}}>등록</Button>
                    }
                    {mode === 'MOD' &&
                        <Button onClick={handleModClick} style={{margin:'0',width:'100px'}}>수정</Button>
                    }
                    {mode === 'MOD' &&
                        <Button onClick={handleDelClick} style={{margin:'0',width:'100px'}}>삭제</Button>
                    }
                </Row>
            </Row>
            <Row>
                <TextField 
                    id='contents' 
                    label='조사내용' 
                    fullWidth 
                    multiline
                    InputLabelProps={{shrink:true}}  
                    rows={2} 
                    size='small' 
                    value={target && target.contents}
                    onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                />
            </Row>
            <Row>
                <TextField 
                    id='descr' 
                    label='비고' 
                    fullWidth 
                    multiline 
                    InputLabelProps={{shrink:true}} 
                    rows={2} 
                    size='small' 
                    value={target && target.descr}
                    onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                />
            </Row>
            <Row>
                <MenuOpenIcon onClick={()=>setItemToggle(!itemToggle)}/>
                자산검색
            </Row>
            <Collapse in={itemToggle} >
                <div style={{height:'35vh', maxHeight:'40vh', overflowY:'auto'}}>
                <CommonDataGrid
                    isLoading={itemLoading}
                    list={list}
                    columns={columns}
                    onRowClick={(e)=>{handleItemClick(e.row)}}
                    />
                </div>
            </Collapse>
        </MainWrap>
    )

}

export default InspectHistItem;